import { FEATURE_NAME } from './consts';

export const CREATE_STORE = `${FEATURE_NAME}/CREATE_STORE`;
